import React from "react";
import $ from 'jquery';

let ws;
export default class BaseApp extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            activeScreen: this.props.activeScreen || 'main',
            ps: []
        };
        this.loadData = ::this.loadData;
        this.setActiveScreen = ::this.setActiveScreen;
        this.start = ::this.start;
        this.check = ::this.check;
        this.onMessage= ::this.onMessage;
    }

    updateParam(id, par) {
        this.setState((oldState)=>{
            oldState.ps[id] = par;
            return oldState;
        })
    }

    apiUrl(type) {
        return `${this.props.base_url}/${type}/${this.props.kp}/`;
    }

    loadData(params, type='cur') {
        let postData=[];
        let apiUrl = this.apiUrl(type);
        for (let key in this.props.psId) {
            postData.push(key);
        }
        $.get(apiUrl).done((data)=>{
            this.setState(
                {ps: data,
                    dataReady: true,
                    connection: true
                });
        }).fail(()=>{
            console.error('Api load failed');
            this.setState({connection: false});
            this.check();
        })

    }

    check() {
        clearTimeout(this.timer);
        this.timer = setTimeout(this.start, 5000);
    }

    start() {
        ws = new WebSocket(this.props.ws_str);
        ws.onopen = () => {
            console.log('WS open');
            this.loadData();
        };
        ws.onmessage = this.onMessage;
        ws.onclose = () => {
            console.error('WS closed');
            this.loadData();
            this.check();
        };
        ws.onerror = () => {
            // console.error('WS error');
        };
    };

    componentDidMount() {
        this.start();
    }


    onMessage(e) {
        try {
            let data = JSON.parse(e.data);
            this.updateParam(data.id, data.param);
            console.log(data);
        }
        catch (err) {
            console.log(err);
        }

    }
    setActiveScreen(screen) {
        this.setState({activeScreen:screen});
    }
}



// WEBPACK FOOTER //
// ./src/lib/core/BaseApp/index.jsx